var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "van-dialog",
    {
      staticClass: "commonTip",
      attrs: {
        "show-confirm-button": _vm.dialogObj.BooleanConfirm,
        "show-cancel-button": _vm.dialogObj.BooleanCancel,
        "confirm-button-color": "#E12817",
        "cancel-button-color": "#666666",
        "confirm-button-text": _vm.dialogObj.dynamicConfirmText,
        "cancel-button-text": _vm.dialogObj.dynamicCancelText
      },
      on: { confirm: _vm.confirmTips, cancel: _vm.cancelDialog },
      model: {
        value: _vm.dialogObj.showTipsRisk,
        callback: function($$v) {
          _vm.$set(_vm.dialogObj, "showTipsRisk", $$v)
        },
        expression: "dialogObj.showTipsRisk"
      }
    },
    [
      _c("div", { staticClass: "title" }, [_vm._v("温馨提示")]),
      _c("div", { staticClass: "stopListContent" }, [
        _vm._v(" " + _vm._s(_vm.dialogObj.dynamicTipsContent) + " ")
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }